<template>
   <label
      :id="id"
      class="status-label"
      :class="{'cursor-pointer': btn && !disabled}"
      :style="{color: variant}"
   >
      {{ text || status }}
   </label>
</template>

<script>
export default {
   props: {
      ident: [String, Number],
      status: String,
      text: {
         type: String,
         default: null,
      },
      btn: Boolean,
      disabled: Boolean,
   },

   computed: {
      id() {
         return `status-${this.ident}`;
      },

      variant() {
         switch (this.status) {
            case this.$constants().StatusType.COMPLETE:
               return '#21b66b';
            case this.$constants().StatusType.IN_PROGRESS:
               return '#0978cc';
            case this.$constants().StatusType.INCOMPLETE:
               return '#999999';
            case this.$constants().StatusType.NA:
               return '#6f8590';
         }
         return null;
      },
   },
};
</script>

<style lang="scss" scoped>
.status-label {
   min-width: 6.5em;
   font-size: 12px;
   margin: 0;
}
</style>
